import Icon from 'veui/components/Icon'
import { IconPaperClip } from 'dls-icons-vue'

Icon.register('paper-clip', IconPaperClip)
